import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import events from './events';
import packages from './packages';
import studies from './studies';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    error: null,
    subscriberId: {
      id: null,
      email: null,
      uid: null,
    },
    loaded: false,
    subscriberData: {},
  },
  getters: {
    apiUrl(state) {
      const esc = encodeURIComponent;
      const query = Object.keys(state.subscriberId)
        .filter(key => state.subscriberId[key])
        .map(key => `${esc(key)}=${esc(state.subscriberId[key])}`)
        .join('&')
      return `${process.env.VUE_APP_API}?${query}`
    },
    studies() {
      return studies;
    },
    packages() {
      return packages;
    },
    events() {
      return events;
    },
    selectedPackage(state, getters) {
      const packages = Object.values(getters.packages);
      return packages.find(pack => pack.name === state.subscriberData.Package) || { includes: {}, options: {} };
    },
    getOption(state, getters) {
      return id => {
        const pack = getters.selectedPackage;
        for (const eventId of Object.keys(pack.includes)) {
          for (const opt of pack.includes[eventId]) {
            if (opt.option.id === id) {
              return opt;
            }
          }
          for (const opt of pack.options[eventId]) {
            if (opt.option.id === id) {
              return opt;
            }
          }
        }
        return null
      }
    },
    getOptionData(state, getters) {
      return id => {
        return state.subscriberData[getters.getOption(id).option.dataField];
      }
    },
    hasEvent(state, getters) {
      return id => {
        const pack = getters.selectedPackage;
        return Object.keys(pack.includes).indexOf(id) >= 0
      }
    },
    totalPrice(state, getters) {
      // package + SUM(options)
      let price = getters.selectedPackage.price;
      for (const eventId of Object.keys(getters.selectedPackage.options)) {
        for (const opt of getters.selectedPackage.options[eventId]) {
          price += getters.getOptionData(opt.option.id) * opt.option.price;
        }
      }
      return price;
    }
  },
  mutations: {
    /* eslint-disable no-param-reassign */
    reloadPackage(state, value) {
      state.subscriberData = value;
      state.loaded = true;
    },
    setSubscriberId(state, subscriber) {
      state.subscriberId = subscriber;
    },
    onError(state, value) {
      state.error = value || 'Something went wrong :(';
    },
    /* eslint-enable no-param-reassign */
  },
  actions: {
    async loadState(context) {
      const result = await axios.get(this.getters.apiUrl,
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          context.commit('reloadPackage', response.data);
        })
        .catch(reason => {
          if (reason.response && reason.response.data) {
            context.commit('onError', reason.response.data);
          } else {
            context.commit('onError', reason);
          }
        });
      return result;
    },
    async saveState(context) {
      const result = await axios.patch(this.getters.apiUrl,
        JSON.stringify(context.state.subscriberData), {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
        .catch(reason => {
          if (reason.response && reason.response.data) {
            context.commit('onError', reason.response.data);
          } else {
            context.commit('onError', reason);
          }
        });
      return result;
    },
  },
});
